<template>
	<transition name="slide">
		<div
			v-if="hasContentSlot && visible"
			:class="`sticky-bar--${position}`"
			data-cy="sticky-bar"
			class="sticky-bar"
		>
			<slot name="content" />
		</div>
	</transition>
</template>

<script>
export default {
	name: 'StickyBar',

	props: {
		position: {
			type: String,
			required: false,
			default: 'bottom',
			validator: value => [
				'bottom',
				'top',
			].indexOf(value) !== -1,
			description: 'Sets where the StickyBar will appear',
		},

		visible: {
			type: Boolean,
			required: false,
			default: true,
			description: 'Sets whether the StickyBar is displayed',
		},
	},

	slots: {
		content: {
			required: true,
			scoped: false,
			description: 'Supplies the content of the StickyBar',
		},
	},

	computed: {
		hasContentSlot() {
			return !!this.$slots.content || !!this.$scopedSlots.content;
		},
	},
};
</script>

<style lang="scss" src="./sticky-bar.scss" />
